'use client';
import { useTableHeadContext } from './table.context.js';
import { createComponent } from '../core/create-component.js';

function _define_property(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function _object_spread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {}, o = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        }))), o.forEach(function(r) {
            _define_property(e, r, t[r]);
        });
    }
    return e;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        t.push.apply(t, o);
    }
    return t;
}
function _object_spread_props(e, r) {
    return r = null != r ? r : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ownKeys(Object(r)).forEach(function(t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    }), e;
}
const TableCell = createComponent({
    displayName: 'TableCell',
    root: 'td',
    propConfig: {
        derivedProps: ()=>({
                isHead: useTableHeadContext()
            }),
        processProps: (e, r)=>r.isHead ? _object_spread_props(_object_spread({}, e), {
                as: e.as || e.component || 'th'
            }) : e,
        classNames: (e, r)=>[
                r.isHead ? 'swan-th' : 'swan-td'
            ]
    }
});

export { TableCell };
